import React from "react"

import { NotificationLink } from "./styles"
import { UpdateTreatmentBanner } from "./update-treatment-banner"
import { BeamUpsellBanner } from "./beam-upsell-banner"
import { AnnualRenewalNotification } from "./annual-renewal-notification"
import { useDashboardNotificationType, DashboardNotificationTypeEnum } from "./use-dashboard-notification-type"
import { Notification } from "./notification"

import { TEST_MARKER_CONSTANTS } from "shared/test-selectors"
import { baseRoutes } from "routes"
import { maybeGetActiveJourney } from "shared/user/helpers"
import { useAssertRootQueryLoaded } from "graphql/smart-queries/user"

export const NOTIFICATION_MESSAGE = {
  notPurchased: "Please check out and start your doctor consultation to get your first month of treatment.",
  quizNotFinished: "Please finish your doctor consultation to get your first month of treatment.",
  treatmentChanged:
    "Your doctor has prescribed you a new treatment plan. Please review and confirm it, so that we can send it your way.",
  newMessage: "You have a new message from your doctor.",
  notAMatch: "Your doctor has sent you a notification about your treatment plan. Please click here to read it.",
  shouldCompleteAnnualRenewal:
    "You'll need to complete your annual renewal consultation before your products will ship.",
  renewalConsultationPending:
    "No action is needed on your part. It usually takes about 24 hours for your doctor to review, and then you'll be set for another year of migraine free days with Cove."
}

const NotificationPicker = () => {
  const notificationType = useDashboardNotificationType()
  const { user } = useAssertRootQueryLoaded()
  const activeJourney = maybeGetActiveJourney(user)
  const kind = activeJourney?.kind

  switch (notificationType) {
    case DashboardNotificationTypeEnum.NotAMatch:
      return (
        <NotificationLink to={baseRoutes.doctorMessaging()} description={NOTIFICATION_MESSAGE.notAMatch}>
          View message
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.ProceedToCheckout:
      return (
        <NotificationLink to={baseRoutes.checkout(kind)} description={NOTIFICATION_MESSAGE.notPurchased}>
          Proceed to checkout
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.AcceptLegals:
      return (
        <NotificationLink to={baseRoutes.confirmTerms(kind)} description={NOTIFICATION_MESSAGE.quizNotFinished}>
          Finish Doctor Consultation
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.FinishConsultation:
      return (
        <NotificationLink
          to={baseRoutes.consultationQuiz(kind)}
          description={NOTIFICATION_MESSAGE.quizNotFinished}
          dataTest={TEST_MARKER_CONSTANTS.DASHBOARD_FINISH_QUIZ_CTA}
        >
          Finish Doctor Consultation
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.TreatmentChanged:
      return (
        <NotificationLink
          to={baseRoutes.treatmentPlan()}
          description={NOTIFICATION_MESSAGE.treatmentChanged}
          dataTest={TEST_MARKER_CONSTANTS.TREATMENT_PLAN_NOTIFICATION}
        >
          View plan
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.RenewalConsultationPending:
      return (
        <Notification
          title="Your annual renewal consultation is being reviewed"
          description={NOTIFICATION_MESSAGE.renewalConsultationPending}
          dataTest={TEST_MARKER_CONSTANTS.ANNUAL_RENEWAL_CONSULT_PENDING_NOTIFICATION}
        />
      )
    case DashboardNotificationTypeEnum.NewMessage:
      return (
        <NotificationLink to={baseRoutes.doctorMessaging()} description={NOTIFICATION_MESSAGE.newMessage}>
          View message
        </NotificationLink>
      )
    case DashboardNotificationTypeEnum.ProceedToAnnualRenewal:
      return <AnnualRenewalNotification />
    case DashboardNotificationTypeEnum.UpdateTreatmentBanner:
      return (
        <>
          <BeamUpsellBanner />
          <UpdateTreatmentBanner />
        </>
      )
    default:
      return null
  }
}

export default NotificationPicker
